import { memo, useEffect } from "react";
import { createPortal } from "react-dom";
import { IoCloseSharp } from "react-icons/io5";
import Loader from "./Loader";
import { noImgShapes } from "../lib/noImgShapes";

function MediaPreviewModal({
    show,
    onClose,
    mediaType,
    item,
    isMediaLoading,
    setIsMediaLoading,
}) {
    // Lock body scroll while open
    useEffect(() => {
        if (!show) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, [show]);

    // Close on Esc
    useEffect(() => {
        if (!show) return;
        const handler = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [show, onClose]);

    if (!show) return null;

    return createPortal(
        <div className="tw-root wahchan-app">
            <div
                className="fixed inset-0 z-[1100] flex items-center justify-center"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={onClose}
            >
                <div
                    className="relative bg-white rounded-lg w-11/12 max-w-3xl p-4"
                    onClick={(e) => e.stopPropagation()}
                >
                    {isMediaLoading && (
                        <div className="iframe-loader-overlay">
                            <Loader message="Loading Media..." />
                        </div>
                    )}
                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={onClose}
                            className="text-2xl text-gray-800"
                            aria-label="Close"
                        >
                            <IoCloseSharp />
                        </button>
                    </div>
                    <div className="flex justify-center items-center">
                        {mediaType === "image" ? (
                            <img
                                className="w-[500px] h-auto object-contain"
                                alt={item?.SHAPE}
                                src={item?.IMAGE || item?.sample}
                                onLoad={() => setTimeout(() => setIsMediaLoading(false), 200)}
                                onError={(e) => {
                                    e.currentTarget.src = item?.sample || noImgShapes.noimage;
                                }}
                            />
                        ) : (
                            <div className="relative w-full" style={{ height: 500 }}>
                                <iframe
                                    title="Video"
                                    src={item?.VIDEO}
                                    height="100%"
                                    width="100%"
                                    frameBorder="0"
                                    onLoad={() => setTimeout(() => setIsMediaLoading(false), 200)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default memo(MediaPreviewModal);
